import { Service } from '@/services/api';
import { Disclaimer } from '@/types/Disclaimer';
import { Announcement } from '@/types/Announcement';

class DisclaimerService extends Service {
  async getDisclaimerByType(disclaimerType: string): Promise<Disclaimer> {
    return this.get<Disclaimer>('/v2/disclaimers', { disclaimerType: disclaimerType }).then(this.handleResponse);
  }

  async getActiveAnnouncements(): Promise<Announcement[]> {
    return this.get<Announcement[]>('/v2/announcements').then(this.handleResponse);
  }

  async acceptDisclaimer(disclaimerId: number): Promise<void> {
    return this.post<void>('/v2/userdisclaimers', { disclaimerId }).then(this.handleResponse);
  }
}

export const disclaimerService = new DisclaimerService();
